function handleFirstTab(e) {
    if (e.keyCode === 9) { // tab
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
    }
}
window.addEventListener('keydown', handleFirstTab);

$(function() {
  	/* Reduced motion: Replace slideToggle(), slideDown(), slideUp() with toggle(), show(), hide() */
  	var oSlideToggle = jQuery.fn.slideToggle;
    jQuery.fn.slideToggle = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.toggle.apply(this, arguments);
      }else{
      	return oSlideToggle.apply(this, arguments);
      }
    };
    var oSlideDown = jQuery.fn.slideDown;
    jQuery.fn.slideDown = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.show.apply(this, arguments);
      }else{
      	return oSlideDown.apply(this, arguments);
      }
    };
    var oSlideUp = jQuery.fn.slideUp;
    jQuery.fn.slideUp = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.hide.apply(this, arguments);
      }else{
      	return oSlideUp.apply(this, arguments);
      }
    };
  	/* End of Reduced Motion */

  	jQuery.fn.sortDomElements = (function() {
        return function(comparator) {
            return Array.prototype.sort.call(this, comparator).each(function(i) {
                  this.parentNode.appendChild(this);
            });
        };
    })();

  	if(!isMobile.any) {
      $('body').addClass('isNotMobile');
    }

    var previousSize = 0;

    var orientation = 0;
    function checkOrientation() {
      var oldval = orientation;
      if (window.innerWidth>window.innerHeight) {
        orientation = 1;
      } else {
        orientation = 2;
      }

      if (oldval != orientation && oldval != 0) {
        $(window).trigger('orientationchange');
      }
    }
    function checkMediaSize() {
      var newSize = window.innerWidth>900 ? 1 : (window.innerWidth>600 ? 2 : 3);
      if (newSize!=previousSize) {
        previousSize = newSize;
        $(window).trigger('mediasizechange');
      }
    }
    $(window).resize(function() {checkOrientation(); checkMediaSize();});
    checkOrientation();$(document).on("click", ".quantity-box .minus", function() {
      	var wrapper = $(this).parent();
    	try {
          wrapper.find('input[type=number]').get(0).stepDown();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())-1);
          wrapper.find('input[type=number]').val((value>=0 ? value : 0));
          wrapper.find('input[type=number]').change();
        }
  	});
  	$(document).on("click", ".quantity-box .plus", function() {
      	var wrapper = $(this).parent();
    	try {
          wrapper.find('input[type=number]').get(0).stepUp();
          wrapper.find('input[type=number]').change();
        } catch(e) {
          var value = (parseInt(wrapper.find('input[type=number]').val())+1);
          wrapper.find('input[type=number]').val(value);
          wrapper.find('input[type=number]').change();
        }
  	});

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });var utilityBar = false;
    var $utilityBar = $('.utility-bar');
    $utilityBar.insertBefore('#header');
    $utilityBar.show();
    var $body = $('body');
    var $header = $('#header');
    function headerScroll() {
      if ($(this).scrollTop()>= ($utilityBar.outerHeight()||0)) {
        $body.addClass('header-fixed');
      } else {
        $body.removeClass('header-fixed');
      }if( $(this).scrollTop()>=80 ) {$('.header-drop').addClass('scroll');$body.addClass('scrolled');
      } else {$('.header-drop').removeClass('scroll');$body.removeClass('scrolled');
      }

    }
    $(window).scroll($.throttle(15, headerScroll));
    headerScroll();

    $('.header-drop .main-menu').html($('#header .main-menu').html());
    $('.header-drop .main-menu a').attr({'focusable':'false','tabindex':'-1','aria-hidden':'true'});
  	setupDropdownMenus();

});

function setupDropdownMenus(){
  var page = $('#page');
  var submenus = $('.submenu');
  var config = {
    over: function () {
      var sm = $(this).find('.submenu:first');
      if (submenus.filter(':visible').not(sm).length == 0)
        sm.slideDown();
      else
        sm.show();
      if (sm.hasClass('has-overlay'))
        page.addClass('submenu-overlay');
    },
    timeout: 400,
    out: function () {
      var sm = $(this).find('.submenu:first');
      if (submenus.filter(':visible').not(sm).length == 0)
        sm.slideUp();
      else
        sm.hide();
      if (submenus.filter(':visible').not(sm).length == 0)
        page.removeClass('submenu-overlay');
    }
  };
  $('.main-menu .has-dropdown, .utils-wrap .has-dropdown').hoverIntent(config);

  $(document).on('keydown', '.main-menu .has-dropdown a:focus', function(e){
    if (e.which == 32) { //Spacebar
      e.preventDefault();
      var sm = $(this).next();
      sm.slideToggle();
      if (sm.hasClass('has-overlay'))
        page.toggleClass('submenu-overlay');
    }
    if (e.which == 40) { //Arrow Down
      e.preventDefault();
      var sm = $(this).next();
      sm.slideDown();
      if (sm.hasClass('has-overlay'))
        page.addClass('submenu-overlay');
    }
    if (e.which == 38) { //Arrow Up
      e.preventDefault();
      var sm = $(this).next();
      sm.slideUp();
      page.removeClass('submenu-overlay');
    }
  });
  $(document).on('keydown', '.main-menu .has-dropdown .has-dropdown a:focus', function(e){
    if (e.which == 39) { //Arrow Right
      e.preventDefault();
      $(this).next().slideDown();
    }
    if (e.which == 37) { //Arrow Left
      e.preventDefault();
      $(this).next().slideUp();
    }
  });
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }

      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}

function initSideCart() {
  if($(window).width() > 600){
    $('.header .cart-wrap').click(function(e){
      e.stopPropagation();
      showSideCart(true);
      return false;
    });
  }

  $(document).click(function(event){
    if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
      hideSideCart();
    }
  });
}

function addMonogram(parentKey, comboKey){
  var monogramData = {
    "id": "40770477293620",
    "quantity": 1,
    "properties[_monogram_parent_key]": parentKey,
    "properties[_monogram_combo_key]": comboKey
  }
  if($("#monogram-text-input").val() != ""){
    monogramData["properties[Monogram Text]"] = $("#monogram-text-input").val();
  }
  if($('#monogram-text-color-input').val() != ""){
    monogramData["properties[Monogram Text Thread Color]"] = $('#monogram-text-color-input').val();
  }
  if($('#monogram-initials-input').val() != ""){
    monogramData["properties[Monogram Initials]"] = $('#monogram-initials-input').val();
  }
  if($('#monogram-initials-color-input').val() != ""){
    monogramData["properties[Monogram Initials Thread Color]"] = $('#monogram-initials-color-input').val();
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: monogramData,
    dataType: 'json',
    error: addToCartFail,
    success: function(jqXHR, textStatus, errorThrown){
      $('#monogram-text-input, #monogram-text-color-input, #monogram-initials-input, #monogram-initials-color-input').val('')
      addToCartSuccess(jqXHR, textStatus, errorThrown);
    },
    cache: false
  });
}

function addEmbroideryUpcharge(parentJqXHR) {
  var upchargeData = {
    "id": "47050833887284",
    "quantity": 1
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: upchargeData,
    dataType: 'json',
    error: addToCartFail,
    success: function(jqXHR, textStatus, errorThrown){
      $('.product-embroidery__input').val('')
      addToCartSuccess(parentJqXHR, textStatus, errorThrown);
    },
    cache: false
  });
}

function addToCart(form) {
	$('#loading-overlay').show();
  	if(modal) modal.close();

  	var productJs = form.closest('.initialized')?.data('productjs');
  	if(productJs) {
    	$(document).trigger("addToCart", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
    } else {
    	$(document).trigger("addToCart", [form]);
    }

  let monogramEnabled = false;
  if ($(".monogram-inputs").attr('data-monogram-enabled')) {
    monogramEnabled = true;
  }

  if (monogramEnabled) {
    var comboKey = Math.floor(100000 + Math.random() * 900000);
    $("#combo-key").attr('name', 'properties[_monogram_combo_key]');
    $("#combo-key").val(comboKey);
  }
  let formData = form.serialize()
  let hasEmbroidery = false
  if ($('.product-embroidery__input').length) {
    if ($('.product-embroidery__input').val().length > 0) {
      hasEmbroidery = true
    } else {
      formData = formData.replace(/&?properties%5BEmbroidery\+Characters%5D=[^&]*/, '')
      formData = formData.replace(/&?properties%5BEmbroidery\+Color%5D=[^&]*/, '')
      formData = formData.replace(/&?properties%5BEmbroidery\+Upcharge%5D=[^&]*/, '')
    }
  }

	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: formData,
		dataType: 'json',
		error: addToCartFail,
    success: function(jqXHR, textStatus, errorThrown){
        if(productJs) {
          $(document).trigger("addToCartSuccess", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
        } else {
          $(document).trigger("addToCartSuccess", [form]);
        }
      if (jqXHR.properties["Has Monogram?"] != "" && monogramEnabled) {
        var parentKey = jqXHR.key;
        
        addMonogram(parentKey, comboKey);
        
      } else if (hasEmbroidery) {
        addEmbroideryUpcharge(jqXHR);
      } else {
        addToCartSuccess(jqXHR, textStatus, errorThrown);
      }
    },
		cache: false
	});
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
  if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
    hideSideCart();
  }
  updateCartDesc(jqXHR, textStatus, errorThrown);
  updateCartAttributes();
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#loading-overlay').hide();
  	Simplistic.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');
}

function updateCartDesc(jqXHR, textStatus, errorThrown){
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          	$('#loading-overlay').hide();

      		var animate = true;
          var scrollPosition = null;
          	if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
              	animate = false;
                scrollPosition = $('#side-cart .content').scrollTop();
            }
          	$('#side-cart').remove();
            if ($('#cart').length>0) {
              data = $(data);
              data.find('#is-a-gift').remove();
            }
          	$('#page').append(data);
          	if(modal) modal.close();
            if (jqXHR.product_id) { //is product
              Simplistic.showProductAdded(jqXHR);
            } else {
              if (!animate) {
          	    showSideCart(animate, scrollPosition); // Simplistic.showProductAdded is called instead
              }
            }
      	}
	});
}

async function updateCartAttributes() {
  const response = await fetch("/cart.js")
  const cart = await response.json()
  const { attributes, items } = cart
  const attrkey = 'Blocked Locations'
  if (items.length < 1) {
    if (attributes) {
      onUpdateCartAttribute(attrkey)
    }
  } else {
    let blockedLocations = []
    items.forEach(item => {
      if (Object.keys(item.properties).length) {
        Object.keys(item.properties).forEach(key => {
          if (key === '_blocked_locations') {
            blockedLocations.push(...item.properties[key].split(','))
          }
        })

      }
    })
    if (blockedLocations.length) {
      onUpdateCartAttribute(attrkey, blockedLocations.join(','))
    } else {
      onUpdateCartAttribute(attrkey)
    }
  }
}

function onUpdateCartAttribute(key, value = '') {
  const formData = new FormData();
  formData.append(`attributes[${key}]`, value)

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => true)
}

function showSideCart(animate, scrollPosition) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay transparent');
  if(animate) {
    setTimeout(function(){
      $('#side-cart').addClass('open')
      if (scrollPosition)
        $('#side-cart .content').scrollTo(scrollPosition);
    }, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){
      $('#side-cart').addClass('ease-animation-slow')
      if (scrollPosition)
        $('#side-cart .content').scrollTo(scrollPosition);
    }, 200);
  }
  Simplistic.trapFocus({
    $container: $('#side-cart'),
    namespace: 'side-cart'
  });
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  setTimeout(function(){$('#page').removeClass('transparent');},500);
  $('body, html').css({overflow: ''});
  Simplistic.removeTrapFocus({
    $container: $('#side-cart'),
    namespace: 'side-cart'
  });
}

window.SimplisticJS = function (){
  var sjs = this;
  this.formatMoney = " \{\{amount\}\}";

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.trapFocus = function(options) {
    options.$container.data('beforeTrapFocus', $(':focus'));
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      //options.$container.removeAttr('tabindex');
    }
    if(options.$container.data('beforeTrapFocus')) {
    	options.$container.data('beforeTrapFocus').focus();
      options.$container.data('beforeTrapFocus', false);
    }

    $(document).off(eventName);
  }

  var diacritics = [
    {char: 'a', base: /[\340-\346]/g},
    {char: 'e', base: /[\350-\353]/g},
    {char: 'i', base: /[\354-\357]/g},
    {char: 'o', base: /[\362-\370]/g},
    {char: 'u', base: /[\371-\374]/g},
    {char: 'n', base: /[\361]/g}
  ];

  this.handleize = function (str, replaceAccentsAndDiacritics) {
    str = str.toLowerCase().replace(/\'|\"/g, "");
    if (replaceAccentsAndDiacritics) {
      diacritics.forEach(function(letter){
        str = str.replace(letter.base, letter.char);
      });
    }
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };

  this.reducedMotion = function() {
  	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openModal = function(content, css) {
    modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: [css]
    });
    modal.setContent(content);
    modal.open();
  }

  this.modalStack = [];
  this.trapFocusOnStack = function(container, options) {
    var elementWithFocus = $(':focus');

    var modal = {
      _options: options || {},
      namespace: 'modal-stack-'+sjs.modalStack.length,
      elementWithFocus: elementWithFocus,
      container: container,
      open: function() {
        Simplistic.trapFocus({
          $container: this.container,
          namespace: this.namespace,
          $elementToFocus: (this._options.elementToFocus ? this._options.elementToFocus : this.container)
        });
      },
      close: function() {
        Simplistic.removeTrapFocus({
          $container: this.container,
          namespace: this.namespace
        });
      }
    };

    if (sjs.modalStack.length>0) {
      sjs.modalStack[sjs.modalStack.length-1].close();
    }
    sjs.modalStack.push(modal);
    modal.open();
  }

  this.removeTrapFocusOnStack = function() {
    var modal = sjs.modalStack.pop();
    if (!modal)
      return;

    modal.close();

    if (sjs.modalStack.length>0) {
      sjs.modalStack[sjs.modalStack.length-1].open();
    }
    if (modal.elementWithFocus.length>0)
      modal.elementWithFocus.focus();
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    images.each(function(){
      var img = new Image();
      img.onload = loadFunction;
      img.onerror = loadFunction;
      img.src = $(this).attr('src');
    });
  };

  this.changeIcon = function () {
    $('.active-wrapper:not(.slick-cloned) a').each(function(i, e){
      if($(e).data("type") == 'video'){
        var index = i + 1;
        $('ul.slick-dots li:nth-child('+index+')').addClass('play');
      }
    });
  };

  var showProducts = new function() {
    var productsShowing = [];
    var self = this;
    var div = null;
    var initialized = false;
    var body = null;
    var headerDefault = null;
    var header = null;

    function position() {
      if (!div)
        return;
      var top = 84;
      if (body.hasClass('header-fixed')) {
        top = header.outerHeight();
        div.css('position', 'fixed');
      } else {
        top = headerDefault.outerHeight();
        div.css('position', 'absolute');
      }
      div.css('top', top+'px');
    }

    self.init = function() {
      if (!initialized) {
        initialized = true;
        body = $('body');
        headerDefault = $('#shopify-section-header')
        header = $('#header');
        $(window).scroll($.throttle(15, position));
      }

      if (!div) {
        div = $('<div class="show-products"></div>');
        $('body').prepend(div);
        $('.page-fixed-bar').addClass('hidden');
      }
      position();
    }
    self.add = function(product, {message, href}) {
      self.init();
      var imageUrl = Simplistic.imageSizeFilter(product.featured_image ? product.featured_image.url : product.image, '_100x');
      $("<img />").on('load', function(){
        var item = $('<div class="show-product" style="display:none;"><div class="wrap"><div class="image" style="background-image: url(\''+imageUrl+'\')"></div><a href="'+href+'"><div class="btn v4 message">'+message+'</div></a><svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-close" viewBox="0 0 32 32"><path fill="#946142" d="M17.825,16l10.208,10.207l-1.827,1.826L16,17.824L5.793,28.033l-1.826-1.826L14.174,16L3.967,5.793l1.826-1.826L16,14.174 L26.208,3.967l1.825,1.826L17.825,16z"></path></svg></div></div')
        div.prepend(item);
        productsShowing.push(item);
        item.closeTID = setTimeout(function() {
          self.delete(item);
        }, 3000);
        item.find('.icon-close').click(function() {
          clearTimeout(item.closeTID);
          self.delete(item);
          return false;
        });
        item.slideDown();
      }).attr("src", imageUrl);
    }
    self.delete = function(item) {
      item.slideUp({complete: function() {
        item.remove();
        var index = productsShowing.indexOf(item);
        productsShowing.splice(index,1);
        if (productsShowing.length == 0) {
          div.remove();
          div = null;
          $('.page-fixed-bar').removeClass('hidden');
        }
      }});
    }
  }

  this.showProductAdded = function (product, options = {message: 'Added To Bag!', href: '/cart'}) {
    showProducts.add(product, options);
  }

  this.customDropdown = function(selectElement, options) {
    var $select = $(selectElement);
    options = options || {};
    var label = options.label || $select.attr('aria-label');
    $('<div class="dropdown-container"></div>').insertAfter($select);
    var owner = $select.next();
    var config = {
      appendTo: owner,
      change: function( event, ui ) {
        $select.addClass('user-selected');
        $select.change()
      },
      select:  function( event, ui ) {
        //setTimeout: let the "change" event run first
        setTimeout(function() {
          if (!$select.hasClass('user-selected')) {
            $select.addClass('user-selected');
            $select.change();
          }
        }, 1);
      }
    }
    if (options.position)
      config.position = options.position;
    if (options.width)
      config.width = options.width;

    $select.selectmenu(config);

    $select.addClass('ui-selectmenu-source');
    var icon = $select.next().find('.ui-selectmenu-icon.ui-icon.ui-icon-triangle-1-s');
    $('<svg aria-hidden="true" tabindex="-1" class="icon icon-arrow-down down-arrow" viewBox="0 0 32 32"><path fill="#4f1f00" d="M26.985,8.5l1.516,1.617L16.001,23.5l-12.5-13.383L5.009,8.5l10.992,11.758L26.985,8.5z"/></svg>').insertAfter(icon);
    icon.remove();
    var menu = owner.find('.ui-selectmenu-menu')
    menu.data('owner', owner);
    menu.data('select', $select);
    if (options.className)
      menu.addClass(options.className);
    menu.find('.ui-menu').addClass('custom_scrollbar');
    menu.click(function(event) {
      if (event.target==this && event.offsetY<0) {
        $select.selectmenu('close');
      }
    });
    if (label) {
      var heading = $('<div class="ui-selectmenu-heading"></div>');
      heading.html(label);
      heading.click(function() {
        $select.selectmenu('close');
      })
      menu.prepend(heading);
    }
    if (window.innerWidth<=600) {
      layoutDropdowns(menu);
    }
  }

  function layoutDropdowns(dropdowns) {
    var ddls = dropdowns || $('.ui-selectmenu-menu');
    var $page = $('#page');
    ddls.each(function(ix, ddl) {
      var $ddl = $(ddl);
      $ddl.data('select').selectmenu('close')
      if (window.innerWidth>600) {
        $ddl.appendTo($ddl.data('owner'))
      } else {
        $ddl.appendTo($page);
      }
    });
  }

  $(function() {
    $(window).on('mediasizechange', $.throttle(50, function(){layoutDropdowns(null)}));
  })

  this.Clipboard = function() {
    function clearSelection() {
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      } else if (document.selection) {
        document.selection.empty();
      }
    }

    function select_all_and_copy(el)
    {
      var result = jQuery.Deferred();
        // Copy textarea, pre, div, etc.
      if (document.body.createTextRange) {
            // IE
            var textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.select();
            textRange.execCommand("Copy");
            result.resolve(el, 'Copied!');
            //tooltip(el, "Copied!");
      }
      else if (window.getSelection && document.createRange) {
            // non-IE
            var editable = el.contentEditable; // Record contentEditable status of element
            var readOnly = el.readOnly; // Record readOnly status of element
            el.contentEditable = true; // iOS will only select text on non-form elements if contentEditable = true;
            el.readOnly = false; // iOS will not select in a read only form element
            var range = document.createRange();
            range.selectNodeContents(el);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range); // Does not work for Firefox if a textarea or input
            if (el.nodeName == "TEXTAREA" || el.nodeName == "INPUT")
              el.select(); // Firefox will only select a form element with select()
            if (el.setSelectionRange && navigator.userAgent.match(/ipad|ipod|iphone/i))
              el.setSelectionRange(0, 999999); // iOS only selects "form" elements with SelectionRange
            el.contentEditable = editable; // Restore previous contentEditable status
            el.readOnly = readOnly; // Restore previous readOnly status
          if (document.queryCommandSupported("copy"))
          {
          var successful = document.execCommand('copy');
          result.resolve(el, 'Copied!');
          if (successful) result.resolve('Copied!');
          else result.reject(el, 'Press CTRL+C to copy');

          if (successful) tooltip(el, "Copied to clipboard.");
            //else tooltip(el, "Press CTRL+C to copy");
        }
        else
        {
          if (!navigator.userAgent.match(/ipad|ipod|iphone|android|silk/i))
            result.reject(el, 'Press CTRL+C to copy');
            //tooltip(el, "Press CTRL+C to copy");
        }
      }
      return result;
    } // end function select_all_and_copy(el)

    function tooltip(el, message)
    {
      var scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft;
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      var x = parseInt(el.getBoundingClientRect().left) + scrollLeft + 10;
      var y = parseInt(el.getBoundingClientRect().top) + scrollTop + 10;
      if (!document.getElementById("copy_tooltip"))
      {
        var tooltip = document.createElement('div');
        tooltip.id = "copy_tooltip";
        el.parentNode.append(tooltip);
      }
      else
      {
        var tooltip = document.getElementById("copy_tooltip")
      }
      tooltip.innerHTML = message;
      $(tooltip).fadeIn();
      setTimeout(function() { $(tooltip).fadeOut()}, 2000);
    }

    return {clearSelection: clearSelection, copy: select_all_and_copy};
  }

  this.longDateString = function(value) {
    var dateParts = value.split('/');
    if (dateParts.length == 3) {
      var newDate = new Date(dateParts[2], dateParts[0]-1, dateParts[1]);
      const months = ['January','February','March','April','May','June','July','August','September','October','November','December']
      return months[newDate.getMonth()] + ' ' + newDate.getDate() + ', ' + newDate.getFullYear();
    } else {
      return value;
    }
  }

  this.bisModal = function(config) {
    var data = $.extend(true, {
      email:"",
      text: "Enter your email address to be notified if this size becomes available again."
      }, config);
    var modalText = data.customModalText ? data.customModalText : data.text
    const html = `
      <div id="simplistic-bis-modal">
        <div class="popup-wrapper">
          <form action="/" method="post">
            <button class="close" aria-label="Close Back In Stock modal form" onclick="$($('.tingle-modal .tingle-modal__close')[0]).click()">
              <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-close icon-close-regular" viewBox="0 0 32 32">
                <path fill="#946142" d="M17.1,16.1l11.2,11.2l-1.1,1.1L16,17.2L4.8,28.4l-1.1-1.1l11.2-11.2L3.7,4.9l1.1-1.1L16,14.9L27.2,3.8l1.1,1.1 L17.1,16.1z"></path>
              </svg>
            </button>
            <h3 class="body_font title-v1 text-center">Notify me</h3>
            <p class="popup-text">${modalText}</p>
            <input type="email" name="email" placeholder="Email" class="form-control input-lg" value="${data.email}" required="required">
            <button class="btn v4" type="submit">Receive notification</button>
            <div class="hide error-message alert h"></div>
            <div class="hide completed-message alert">You&#39;re in! We&#39;ll let you know when it&#39;s back. <button type="button" class="link-close" onclick="$($('.tingle-modal .tingle-modal__close')[0]).click()">Close</button>
          </form>
        </div>
      </div>
    `
    Simplistic.openModal(html, 'simplistic-bis-modal');
    var modal = $('#simplistic-bis-modal');
    modal.find('form').on('submit', function(event){
      var divalert = modal.find('.alert')
      var submit = modal.find('[type="submit"]');
      submit.prop('disabled', true);
      divalert.slideUp();
      event.preventDefault();
      $.ajax({
        type: "POST",
        url: 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=JVwBF7',
        headers: {
          'accept': 'application/vnd.api+json',
          'revision': '2024-10-15',
          'content-type': 'application/vnd.api+json'
        },
        data: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: ['EMAIL', 'SMS'],
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: modal.find('[name="email"]').val(),
                  }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${data.variant_id}`
                }
              }
            }
          }
        }),
        contentType: 'application/vnd.api+json',
        dataType: 'json',
        statusCode: {
          202: function(response) {
            divalert.filter('.completed-message').fadeIn();
            submit.hide();
          },
        }
      }).fail(function(response) {
        if (response.status === 202) return
        submit.prop('disabled', false);
        const msg = 'Oops! It looks like something’s missing. Please double-check your email.'

        divalert.filter('.error-message').html(msg).slideDown();
      });
    })
  }

  this.imageSizeFilter = function(imageUrl, filter) {
    var parts = imageUrl.split('.');
    parts[parts.length-2] = parts[parts.length-2] + filter;
    imageUrl = parts.join('.');
    return imageUrl;
  }

  this.swipedetect = function(el, callback){

    var touchsurface = el,
    swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, //required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 300, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    handleswipe = callback || function(swipedir){}

    touchsurface.addEventListener('touchstart', function(e){
        var touchobj = e.changedTouches[0]
        swipedir = 'none'
        dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY
        startTime = new Date().getTime() // record time when finger first makes contact with surface
    }, false)

    touchsurface.addEventListener('touchmove', function(e){
        e.preventDefault() // prevent scrolling when inside DIV
    }, false)

    touchsurface.addEventListener('touchend', function(e){
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
            }
        }
        handleswipe(swipedir)
    }, false)
  }

  this.NewestProducts = new function() {
    var productsCache  = new function() {
      var prods_storage = localStorage;
      var storage_key = 'sjs_newest_prods'
      var expiration = 1000 * 3600; //1000 * seconds
      this.set = function(items) {
        prods_storage.setItem(storage_key, JSON.stringify({items: items, time: new Date().getTime()}));
      }
      this.get = function() {
        var strdata = prods_storage.getItem(storage_key);
        var data = null;
        if (strdata) {
          data = JSON.parse(strdata);
          if (data.time + expiration < new Date().getTime()) {
            prods_storage.removeItem(storage_key);
            return null;
          }
        }
        return data;
      }
      this.delete = function() {
        prods_storage.removeItem(storage_key);
      }
      return {set:this.set,get:this.get,delete:this.delete};
    };

    this.clearCache = function() {
      productsCache.delete();
    }

    this.load = function(callback) {
      var cacheData = null;
      try {
        cacheData = productsCache.get();
      } catch(e) {
        console.error(e);
      }
      if (cacheData==null) {
        $.get('/collections/newest-products?view=ajax').done(function(data) {
          var prods = JSON.parse(data);
          var period = 86400000 * 30 //day * n
          var limit = 5;
          var items = [];
          for (var i=0; i<prods.length && i<limit; i++) {
            if ( (new Date() - new Date(prods[i].created_at)) < period) {
              items.push(prods[i]);
            }
          }
          if (callback) {
            callback(items);
          }
          productsCache.set(items);
        });
      } else {
        if (callback) {
          callback(cacheData.items);
        }
      }
    }
  }
};
window.Simplistic = new SimplisticJS();

var timeoutPromise;
var observerPLP = null;
function plp_scripts() {
  // function nodeChanged (mutationRecord, mutationObserver) {
  //   if(timeoutPromise) clearTimeout(timeoutPromise);
  //   timeoutPromise = setTimeout(() => {
  //     window.dispatchEvent(new Event('resize'));
  //   }, 500);
  // }

  // const observerOptions = {
  //   childList: true
  // }

  // if(!observerPLP){
  //   observerPLP = new MutationObserver(nodeChanged);
  //   observerPLP.observe(targetNode, observerOptions);
  // }

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  if (Shopify.queryParams.sort_by) {
    var option = $('input[name="sort-by"][value="'+Shopify.queryParams.sort_by+'"]');
    option.prop('checked', true);
    option[0].previous = true;
    showSelectedOrder();
  }

  function togglePanel(buttonParent) {
    var button = buttonParent.find('button:visible');
    var panelName = buttonParent.text().trim();
    button.toggleClass('open');
    if (button.hasClass('open')) {
      button.attr('aria-expanded', 'true');
      button.attr('aria-label', 'Collapse '+panelName+' panel');
    } else {
      button.attr('aria-expanded', 'false');
      button.attr('aria-label', 'Expand '+panelName+' panel');
    }
    buttonParent.next().slideToggle();
  }

  $(document).on('click', '.filter-menu .title', function() {
    var button = $(this).find('button:visible');
    if (button.length>0) {
      var openedButton = button.closest('.filter-menu').find('button.open');
      if (openedButton.length>0 && openedButton[0]!=button[0]) {
        togglePanel(openedButton.parent());
      }
      togglePanel($(this));
    }
  })

  $(document).on('keydown', function(e){
    if (e.which == 27) { //Exit
      $('.filter-menu:visible .close').click();
      $('.sort-menu:visible .close').click();
    }
  });


  function toggleFilterMenu(boolOpen) {
    if (boolOpen) {
      if (window.innerWidth<=600)
        $('body, html').css({overflow: 'hidden'});
      $('.filter-menu, .filter-menu-overlay').fadeIn();
      Simplistic.trapFocus({
        $container: $('.filter-menu'),
        namespace: 'filter-menu',
        $elementToFocus: $('.filter-menu .title button:first')
      });
    } else {
      $('body, html').css({overflow: 'auto'});
      $('.filter-menu, .filter-menu-overlay').fadeOut();
      Simplistic.removeTrapFocus({
        $container: $('.filter-menu'),
        namespace: 'filter-menu'
      });
    }
  }

  $('.filters-select-btn').click(function(event) {
    toggleFilterMenu(true);
  })

  $('.filters-apply-btn').click(function(event) {
    toggleFilterMenu(false);
  })

  $('.filters-clear-btn').click(function(event) {
    $('.filter-menu input:checked').prop('checked', false);
    $('.filters-apply-btn').click();
  })

  $('.filter-menu .close, .filter-menu-overlay').click(function(event) {
    toggleFilterMenu(false);
  });

  function toggleSortMenu(boolOpen) {
    if (boolOpen) {
      if (window.innerWidth<=600)
        $('body, html').css({overflow: 'hidden'});
      $('.sort-menu, .sort-menu-overlay').fadeIn();
      Simplistic.trapFocus({
        $container: $('.sort-menu'),
        namespace: 'sort-menu',
        $elementToFocus: $('.sort-menu .items input:first')
      });
    } else {
      $('body, html').css({overflow: 'auto'});
      $('.sort-menu, .sort-menu-overlay').fadeOut();
      Simplistic.removeTrapFocus({
        $container: $('.sort-menu'),
        namespace: 'sort-menu',
      });
    }
  }

  $('.sort-select-btn').click(function(event) {
    toggleSortMenu(true);
  })

  var sortRadioButtons = $('.sort-menu input[type=radio]');
  sortRadioButtons.on('click', function() {
    if (this.previous) {
        this.checked = false;
    }
    this.previous = this.checked;
  });

  sortRadioButtons.on('change', function() {
    var self = this;
    sortRadioButtons.each(function(ix, e) {
      if (e!=self) {
        e.previous = false;
      }
    })
  });

  function showSelectedOrder() {
    var text = $('[name="sort-by"]:checked').next().text();
    $('.sort-select-btn .selected-order').html(': <span>'+text+'</span>');
  }

  $('.sort-apply-btn').click(function(event) {
    toggleSortMenu(false);
    var value = $('[name="sort-by"]:checked').val();
    if (Shopify.queryParams.sort_by != value) {
      if (value)
        Shopify.queryParams.sort_by = value;
      else
        delete Shopify.queryParams.sort_by;
      delete Shopify.queryParams.page;
      showSelectedOrder();
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    }

  })

  $('.sort-clear-btn').click(function(event) {
    $('.sort-menu input:checked').prop('checked', false);
    $('.sort-apply-btn').click();
  })

  $('.sort-menu .close, .sort-menu-overlay').click(function(event) {
    toggleSortMenu(false);
  });

  function collectionTopLayout() {
    if (window.innerWidth <= 600) {
      $('.collection-top:not(.collection-top--stick)').prependTo('#collection');
    } else {
      $('.collection-top').appendTo('#header');
    }
  }

  $(window).resize($.throttle(50, collectionTopLayout));
  collectionTopLayout();
  window.contentPaddingTop = function (){
    $('.header-spacer').height($('#header').outerHeight() - $('#header .utility-bar').outerHeight());
  }
  contentPaddingTop();

  //Reveal effect
  var lazyLoadingItems = [];
  var lazyLoadingFound = false;
  var loadingIntervalId = setInterval(function() {
    if (lazyLoadingItems.length==0) {
      lazyLoadingItems = $('#collection .img-wrapper .img.lazyloading');
    } else {
      if (lazyLoadingItems.filter('.lazyloading').length==0) {
        clearInterval(loadingIntervalId);
        document.body.classList.remove('plp-carousels-pending');
      }
    }
  },50);

}

function plp_itemCarousel(item, slider, conf) {
  slider.on('plp-image-carousel:loaded', () => {
    const firstItems = item.find('.slick-slide[data-index="0"]')
    if (firstItems.length) {
      const [firstItem] = firstItems
      const indexOfFirstItem = Number(firstItem.dataset.slickIndex) || 0
      slider.slick('slickGoTo', indexOfFirstItem, true)
    }
    item.find('.loading-layer').remove();
    item.addClass('slider-init');
  })
  slider.on('init', function (slick) {
    setTimeout(() => slider.trigger('plp-image-carousel:loaded'), 100)
  });
  slider.slick(conf);
}

function sizeguide_scripts(table) {

  function initSizeGuide(table) {
    if (table.length == 0)
      return;

    var values = $('#detailed-measures-values').val().split('-').filter(function (e) { return e != '' })

    if (!values) { return }
    // var values = [
    //   '5,35,2.5,21.5,1',
    //   '5.5,35.5,3,22,2',
    //   '6,36,3.5,22.5,3',
    //   '6.5,36.5,4,23,4',
    //   '7,37,4.5,23.5,5',
    //   '7.5,37.5,5,24,6',
    //   '8,38,5.5,24.5,7',
    //   '8.5,38.5,6,25,8',
    //   '9,39,6.5,25.5,9',
    //   '9.5,39.5,7,26,10',
    //   '10,40,7.5,26.5,11',
    //   '10.5,40.5,8,27,12',
    //   '11,41,8.5,27.5,13',
    //   '11.5,41.5,9,28,14',
    //   '12,42,9.5,28.5,15'
    // ]

    var selects = table.find('td select');
    var tableDetailedMeasures = table.closest('.info-popup').find('.table-guide.measures');

    values.forEach(function(value) {
      for (var i=0; i<5; i++) {
        var parts = value.split(',');
        selects[i].options.add(new Option(parts[i],parts[i]));
      }
    })
    selects.on('change', function() {
      var index = this.selectedIndex;
      var self = this;
      selects.each(function(ix, select) {
        if (select != self) {
          select.selectedIndex = index;
          var $select = $(select);
          if ($select.hasClass('ui-selectmenu-source'))
            $select.selectmenu('refresh');
        }

      })
      var usSize = selects[0].value;
      filterDetailedMeasurements(usSize);
    });
    selects.each(function(ix, select) {
      Simplistic.customDropdown(select, {
        position: { my : "center top-65", at: "center center" },
        className: 'size-ddl'
      });
    });

    function filterDetailedMeasurements(usSize) {
      tableDetailedMeasures.find('tr').each(function(ix, tr) {
        if (ix>0) {
          var $tr = $(tr);
          if (usSize=='')
            $tr.show();
          else {
            if ($tr.find('td:eq(0)').text() == usSize)
              $tr.show();
            else
              $tr.hide();
          }
        }
      });
    }

  }
  initSizeGuide(table);

}

function pdp_scripts(product) {
  var productId = product.id;
  if(window.location.hash.indexOf('search') >= 0) {
    $('.collection-nav .return_search').removeClass('hide');
  }

  var sizeSwatches = $('.swatch-size .swatch-element');
  var sizeDrop = $('#fxb-option-size');
  if (sizeSwatches.length>=2) {
    sizeSwatches.closest('.swatch-size').addClass('must-select');
    sizeDrop.addClass('must-select');
    $('<span class="fxb-select-caption" style="position: absolute;bottom: 0.8em;font-size: 0.8em;z-index: -1;">SELECT SIZE</span>').insertAfter(sizeDrop);
  }

  var colorSwatches = $('.swatch-color .swatch-element.color');
  if (colorSwatches.length>0) {
    var colorSwatchesParent = colorSwatches.first().parent();
    colorSwatches.sort(function(a,b) {
      return $(a).data('value') > $(b).data('value') ? 1 : -1;
    }).appendTo(colorSwatchesParent);
  }

  var colorDropOptions = $('#fxb-option-color option');
  if (colorDropOptions.length>0) {
    var colorDropOptionsParent = colorDropOptions.first().parent();
    colorDropOptions.sort(function(a,b) {
      return a.value > b.value ? 1 : -1;
    }).appendTo(colorDropOptionsParent);
  }

  var modalStack = [];
  function openModalOnStack(content, openMethod, closeMethod, options) {
    options = options || {};
    var modal = {
      content: content,
      close: closeMethod,
      open: openMethod
    }

    modalStack.push(modal);
    if (typeof(options.overflow)=="undefined")
      options.overflow = 'hidden';
    if (typeof(options.overlayClass)=="undefined")
      options.overlayClass = 'overlay-light';
    $('body, html').css({overflow: options.overflow});
    $('#page').addClass('mode-overlay '+options.overlayClass);

    modal.open();
    Simplistic.trapFocusOnStack(content);
  }

  function closeModalOnStack() {
    var modal = modalStack.pop();
    if (modal) {
      modal.close();
      Simplistic.removeTrapFocusOnStack();
      $('body, html').css({overflow: ''});
      var page = $('#page');
      page.removeClass('mode-overlay');
      setTimeout(function() {
        page.removeClass('overlay-light overlay-transparent');
      }, 400)
    }
  }

  var productWrap = $('.product-wrap');
  var productItem = $('#product-item-'+productId);
  var productJs = productItem.data('productjs');
  var productInfo = productItem.find('.product-info');
  var productInfoFooter = productInfo.find('.product-info-footer');
  var colorCount = productInfo.find('.swatch-element.color').length;
  productInfo.find('.color-count').html(colorCount + (colorCount > 1 ? '&nbsp;colors' : '&nbsp;color'));
  var collectionNav = $('.collection-nav');
  var collectionNavButtons = collectionNav.find('a');
  var productDescription = productInfo.find('.description');
  var measures = productDescription.find('.measures');
  var sizeGuide = $('#product-size-guide');
  var productCareBadges = $('#product-care .badges');
  var detailsContainer = $('.product-details-container');
  var swatchDropdownElements = $('.product-wrap .swatch-dropdown .swatch-elements-wrapper');
  var swatchColor = $('.product-wrap .swatch-color');
  var swatchSize = $('.product-wrap .swatch-size');
  var swatchColorPrev = swatchColor.prev();
  var swatchColorElements = swatchColor.find('.swatch-elements-wrapper');
  var infoButtons = productWrap.find('.info-button');
  var productCareContainers = $('#product-care').find('.wrapper[data-variant]');
  var inventoryLocationInformation = $('#customInventoryLocationInformation');
  var section = $('#shopify-section-product');
  infoButtons.last().addClass('last');

  if (measures.length>0) {
    var detailedMeasures = sizeGuide.find('.detailed-measures').removeClass('hide');
    if (detailedMeasures.length>0) {
      measures.removeClass('hide').insertAfter(detailedMeasures);
      sizeGuide.find('.table-guide').addClass('table-guide-description');
    }
  }
  sizeGuide.find('.table-guide').addClass('title-v1');
  swatchDropdownElements.addClass('fixed-modal-bottom ease-animation');

  function layout() {
    if (window.innerWidth>900) {
      productInfo.find('.nav-and-main').prepend(collectionNav);
    } else {
      productWrap.prepend(collectionNav);
    }

    if (window.innerWidth>600) {
      productInfoFooter.append(swatchColor);
      swatchColorElements.removeClass('fixed-modal-bottom ease-animation');
      // infoButtons.insertAfter(productDescription);
      infoButtons.removeClass('title-v1');
    } else {
      swatchColor.insertAfter(swatchColorPrev);
      swatchColorElements.addClass('fixed-modal-bottom ease-animation');
      // productInfo.append(infoButtons);
      infoButtons.addClass('title-v1');
    }
  }
  $(window).on('mediasizechange', $.throttle(50, layout));

  layout();
  section.removeClass('layout-pending');

  var inventoryInfo = null;
  var productIds = [];
  product.variants.forEach(function(variant) {
    if (variant.product && productIds.indexOf(variant.product.id)==-1) {
      productIds.push(variant.product.id);
    }
  });
  function prepareInventoryInfo() {
    try {
      inventoryInfo = tomitProductInventoryInfo.getProductsInventoryInformation(productIds);
      inventoryInfo?.then(showVariantInventoryInfo);
    } catch (e) {
      console.error(e);
    }
  }
  function showVariantInventoryInfo(data) {
    try {
      var variant = productJs.getCurrentVariant();
      var productInfo = data[variant.product.id].product;
      var locations = productInfo.variants[variant.id].inventoryItem.locations;
      var ul = $('<ul id="tomit_inventory_list"></ul>');
      inventoryLocationInformation.empty();
      inventoryLocationInformation.append(ul);
      locations.forEach(function(location) {
        var li = $('<li data-loc="' + location.id + '" class="tomitIsInStock"><small>' + location.name + ': <strong>' + location.available + '</strong></small></li>');
        ul.append(li);
      });

    } catch (e) {
      console.error(e);
    }
  }
  if (window.tomitProductInventoryInfo) {
    prepareInventoryInfo();
  } else {
    document.addEventListener('tomitLoaded', function() {
      prepareInventoryInfo();
    });
  }

  productItem.on('variantChange', function(e, variant) {
    document.querySelectorAll('.main-single-image').forEach(el => {
      el.classList[+el.dataset.productId === +variant.product.id ? 'remove' : 'add']('!hide')
    })

    Simplistic.changeIcon();
    /* Size Guide
    -------------------------------------------- */
    const description = variant.product.description;
    const tempElement = document.createElement('span');
    tempElement.innerHTML = description;
    const table = tempElement.querySelector('.table-guide.measures');
    if(table){
      table.classList.add('table-guide-description');
      table.classList.add('title-v1');
      table.classList.remove('hide');
      $('#product-size-guide .table-guide-description').remove();
      const detailedMeasuresDiv = document.querySelector('#product-size-guide .detailed-measures');
      if(detailedMeasuresDiv){
        detailedMeasuresDiv.insertAdjacentElement('afterend', table);
      }
    }
    $('.slick-slider .slick-slide video').each(function(video){
      $('.slick-slider .slick-slide video')[video].play();
    });

    var notSelected = productItem.find('.options .swatch.must-select').not('.selected');
    var buttonAdd = productItem.find('[name="add"], #pdp-fixed-bar .btn');
    if (notSelected.length > 0) {
      buttonAdd.prop('disabled', true);
    } else {
      buttonAdd.prop('disabled', false);
    }

    if (inventoryInfo) {
      //update inventory information
      inventoryInfo.then(showVariantInventoryInfo);
    }

    /*
    //Update URL
    var urlVariantId = Simplistic.getQueryParam('variant');
    if (urlVariantId != ''+variant.id) {
      var newUrl = location.href + (location.href.indexOf('?')==-1 ? '?' : '');
      if (urlVariantId===null) {
        newUrl += 'variant='+variant.id;
      } else {
        newUrl = newUrl.replace('variant='+urlVariantId, 'variant='+variant.id);
      }
      var regex = new RegExp(/products\/.*\?/)
      var regmatch = newUrl.match(regex);
      newUrl = newUrl.replace(regmatch[0], 'products/'+variant.product.handle+'?')
      history.replaceState({},'', newUrl);

      $('.product-wrap [data-selectedlabel="Share"]').each(function(ix, item) {
        var $item = $(item);
        var shareUrl = $item.data('href');
        var paramName = Simplistic.getQueryParam('url', shareUrl) !== null ? 'url' : (Simplistic.getQueryParam('u', shareUrl) !== null ? 'u' : '');
        if (paramName) {
          var paramValue = Simplistic.getQueryParam(paramName, shareUrl);
          shareUrl = shareUrl.replace(paramName+'='+encodeURIComponent(paramValue), paramName+'='+encodeURIComponent(newUrl));
          shareUrl = shareUrl.replace(paramName+'='+paramValue, paramName+'='+encodeURIComponent(newUrl));
        } else {
          shareUrl = newUrl;
        }
        $item.data('href', shareUrl);
      })
    }*/


    var variantDataContainers = $('#pdp-fixed-bar, .product-info-main, #product-details-sizing, #product-care, #image-text-modules');
    variantDataContainers.find("[data-vdvisibility]").each(function(ix, node) {
      var $node = $(node);
      var key = $node.data('vdvisibility');
      var value;
      var contain = $node.data('vdcontain');
      eval("value = variant"+(key.charAt(0)!="[" && key.charAt(0)!="." ? "." : "" ) + key);
      if (value) {
        if (!contain || value.indexOf(contain)>-1) {
          $node.removeClass('forcehide');
        } else {
          $node.addClass('forcehide');
        }
      } else {
        $node.addClass('forcehide');
      }
    });
    variantDataContainers.find("[data-vdvalue]").each(function(ix, node) {
      var $node = $(node);
      var key = $node.data('vdvalue');
      var value;
      var match = $node.data('vdmatch');
      eval("value = variant"+(key.charAt(0)!="[" && key.charAt(0)!="." ? "." : "" ) + key);
      if (value) {
        value += '';
        $node.removeClass('forcehide');
        if (!match) {
          if ($node[0].tagName=='INPUT')
            $node.val(value);
          else
            $node.html(value);
        } else {
          if (value.toLowerCase()==match.toLowerCase()) {
            $node.addClass('selected');
          } else {
            $node.removeClass('selected');
          }
        }
      } else {
        $node.addClass('forcehide');
      }
    });

    initProductCare(); //run after vdvalue changes applied
    $('#image-text-modules .block:not(.forcehide) .slick-slider').slick('refresh');

    productItem.find('.final-sale-message')[variant.metafields?.finalsale ? 'removeClass' : 'addClass']('hide');
    productItem.find('.final-sale-message-with-credit')[variant.metafields?.finalsale_with_credit ? 'removeClass' : 'addClass']('hide');

    var buttons = productItem.find('.content-available .btn:not(.mandatory-option-btn), .content-available.btn');

    if(variant.metafields['presale']){
      var datestr = Simplistic.longDateString(variant.metafields['presale']);
      var msg = 'Ships by ' +datestr + '<input type="hidden" name="properties[preorder]" value="'+variant.metafields['presale']+'">';
      productItem.find('.presale-message').html(msg).show();
      buttons.html('Preorder Now');
    }else{
      productItem.find('.presale-message').html('').hide();
      buttons.each(function (ix, button) {
        if (button.dataset.charm) {
          button.innerHTML = 'Add a charm';
          button.addEventListener('click', function(e) {
            e.preventDefault();
            Simplistic.openModal($('#charms-pop-up'), 'charms-popup');
          });
        } else {
          button.innerHTML = 'Add to Bag';
        }
      });
      //buttons.html('Add to bag');
    }
    if (swatchSize.hasClass('must-select')) {
      buttons.html('Select a size');
      $('.low-stock').addClass('forcehide');
    } else {
      sizeDrop.removeClass('must-select');
      $('.low-stock').removeClass('forcehide');
    }

    fixedBarSelects.each(function (ix, select) {
      var $select = $(select);
      var option = 'option' + $select.data('option');
      select.value = variant[option];

      //update soldout state
      var swatches = productWrap.find('[data-option-index="'+($select.data('option')-1)+'"] .swatch-element');
      swatches.each(function(ixr, swatchElement) {
        var $swatchElement = $(swatchElement);
        var op = $select.find('option[value="'+$swatchElement.data('value')+'"]');
        if ($swatchElement.hasClass('soldout')) {
          $(op).addClass('soldout');
        } else {
          $(op).removeClass('soldout');
        }
      });

      if ($select.hasClass('ui-selectmenu-source'))
        $select.selectmenu('refresh');
    });

    checkHeight();

    section.removeClass('layout-pending');
  }); //end productItem on variantChange

  sizeguide_scripts(sizeGuide.find('.table-guide.size'));

  var badges = [];badges.push({
        tag: "Dry Clean",
        text: "Dry Clean",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/DRYCLEAN.png?v=1787129217",
        icon: "\u003csvg aria-hidden=\"true\" focusable=\"false\" role=\"presentation\" class=\"icon icon-professional-care up-arrow\" viewbox=\"0 0 32 32\"\u003e\u003cpath d=\"M28.1,12.2c-0.1,0-0.1-0.1-0.2-0.1L17.1,7.5v-1c0-0.6-0.5-1.1-1.1-1.1c-0.9,0-1.7-0.8-1.7-1.7 c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7h2.1C19.8,1.7,18.1,0,16,0s-3.8,1.7-3.8,3.8c0,1.7,1.2,3.2,2.7,3.6v0.1L4.1,12.1 c-0.1,0-0.1,0.1-0.2,0.1c-1,0.7-1.6,1.8-1.6,3c0,2.1,1.9,3.8,4.3,3.8h1.3v13h16V19h1.4c2.4,0,4.3-1.7,4.3-3.8 C29.7,14,29.1,13,28.1,12.2z M25.4,16.9h-1.4v-1.6h-16v1.6H6.6c-1.2,0-2.2-0.8-2.2-1.7c0-0.6,0.4-1,0.6-1.2L16,9.4L26.9,14 c0.3,0.2,0.6,0.6,0.6,1.2C27.6,16.1,26.6,16.9,25.4,16.9z\"\u003e\u003c\/path\u003e\u003c\/svg\u003e"
      });badges.push({
        tag: "Machine Wash",
        text: "Machine Wash",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/MACHINEWASH.png?v=1787129217",
        icon: "\u003csvg aria-hidden=\"true\" focusable=\"false\" role=\"presentation\" class=\"icon icon-no-alcohol up-arrow\" viewbox=\"0 0 32 32\"\u003e\u003cpath d=\"M30.6,31l-7.7-7.7c1.6-1.7,2.6-3.9,2.6-6.4c0-5.6-5.6-9.4-9.4-16.9C14,4.1,11.4,7.1,9.4,9.9L1.1,1.6l-1,1 L8.7,11c-1.2,1.9-2,3.8-2,5.9c0,5.2,4.2,9.4,9.4,9.4c2.2,0,4.3-0.8,5.9-2.1l7.7,7.7L30.6,31z\"\u003e\u003c\/path\u003e\u003c\/svg\u003e"
      });badges.push({
        tag: "Avoid Sunlight",
        text: "Avoid Storing in Sunlight",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/NOSUN.png?v=1787129217",
        icon: ""
      });badges.push({
        tag: "Store Box",
        text: "Store in Box Provided",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/SHOEBOX.png?v=1787129217",
        icon: ""
      });badges.push({
        tag: "Spot Clean",
        text: "Spot Clean",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/SPOTCLEAN.png?v=1787129217",
        icon: ""
      });badges.push({
        tag: "Avoid Water",
        text: "Avoid Water",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/AVOIDWATER-06.png?v=1787129219",
        icon: ""
      });badges.push({
        tag: "Dust Bag",
        text: "Store in Dust Bag",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/DUSTBAG.png?v=1787129219",
        icon: ""
      });badges.push({
        tag: "Professional Care",
        text: "Professional Care",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/PROFESSIONALCARE.png?v=1787129219",
        icon: ""
      });badges.push({
        tag: "Hand Wash",
        text: "Hand Wash",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/HANDWASH.png?v=1787129317",
        icon: ""
      });badges.push({
        tag: "Handbag Storage",
        text: "Store Safely",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/HANDBAGONHOOK.png?v=1787129321",
        icon: ""
      });badges.push({
        tag: "Avoid Abrasion",
        text: "Avoid Abrasive Materials",
        icon_img: "\/\/cdn.shopify.com\/s\/files\/1\/0253\/4385\/2596\/files\/ABRASIVEMATERIALS.png?v=1787129321",
        icon: ""
      });//
  //replace tags with Badges
  function initProductCare() {

    productCareBadges.each(function(ix, badgeContainer) {
      var $container = $(badgeContainer);
      var tags = $container.text().split(',');
      tags = $.map(tags, $.trim);
      $container.html('');
      var badgesAdded = [];
      badges.forEach(function(badge) {
        if (tags.indexOf(badge.tag)>-1) {
          if (badgesAdded.length>0)
          $container.append('<div class="separator" style="border-left: 2px solid #D4BAAA;"></div>');
          badgesAdded.push(badge);
          $container.append('<div class="badge">'+(badge.icon_img?'<img class="icon img-icon" src="'+badge.icon_img+'" />':badge.icon)+'<div class="title-v1">'+badge.text+'</div></div>')
        }
      });
      if (badgesAdded.length<3)
        $container.addClass('center');
    })

  }

  //initProductCare(); //now runs on variant change

  $('.info-popup').click(function(event) {
    if (event.target==this && event.offsetX<0) {
      $(this).find('.close').click();
    }
  });

  $('.product-wrap button[data-target], .info-popup button[data-target]').click(function() {
    var button = this;
    var modalId = $(this).data('target');
    var modal = $('#' + modalId);
    var scrollWidth = window.innerWidth - $(window).width();
    $('body, html').css({overflow: 'hidden'});

    var buttonBack = modal.find('.close-back');
    if (Simplistic.modalStack.length>0) {
      buttonBack.show();
    } else {
      buttonBack.hide();
    }

    //css fixes
    if (scrollWidth>0) {
      $('body').css('margin-right', scrollWidth+'px');
      $('.header-fixed #header, .force-header-fixed #header').css({width: 'calc(100% - '+scrollWidth+'px)', right: ''})
      if (window.innerWidth>900)
        modal.css('width', 'calc(55% + '+(scrollWidth/2)+'px)');
      else
        modal.css('width', '');
    }

    modal.toggle("slide", {direction: 'right', complete: function() {button.disabled='';}})
    Simplistic.trapFocusOnStack(modal);
    button.disabled = 'disabled'; //disable must go after trapFocus

    var modalClose = modal.find('button.close, button.close-back').not('.initialized');
    modalClose.addClass('initialized').click(function() {
      modal.toggle("slide", {direction: 'right'})
      Simplistic.removeTrapFocusOnStack();

      if (Simplistic.modalStack.length == 0) {
        $('body, html').css({overflow: ''});

        //css fixes
        $('body').css('margin-right', '');
        $('.header-fixed #header, .force-header-fixed #header').css({width: '100%', right: '0'})

      } else if (modal.find('button.close-back:visible').length>0 && $(this).hasClass('close')) {
        Simplistic.modalStack[Simplistic.modalStack.length-1].container.find('button.close').click()
      }
    });

  });

  $('.product-wrap input[type=radio]').bind("keypress", function (e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      closeModalOnStack();
      return false;
    }
  });
  $('.product-wrap .swatch-color input[type=radio] + label, .product-wrap .swatch-dropdown input[type=radio] + label').click(function(e) {
    if ($(this).closest('.swatch-elements-wrapper').hasClass('fixed-modal-bottom')) {
      closeModalOnStack();
    }
  })

  $('.page-overlay').click(function(event){
    closeModalOnStack();
  });

  $(window).on('mediasizechange', closeModalOnStack);
  productWrap.find('.swatch .close').click(closeModalOnStack);

  $('.page-overlay').on('touchmove', function(event){
    event.preventDefault();
  });

  productWrap.find('.btn-open-select-colors, .btn-open-select').click(function() {
    var dropdownModal = $(this).closest('.swatch').find('.swatch-elements-wrapper')
    var options = {};
    var delay = 400;
    if (window.innerWidth>600 && $(this).hasClass('btn-open-select')) {
      options.overlayClass = 'overlay-transparent';
      options.overflow = '';
      delay = 1;
    }
    openModalOnStack(dropdownModal,
      function() {
        dropdownModal.show();
        setTimeout(function(){
          dropdownModal.addClass('open');
        },1);
      },
      function() {
        dropdownModal.removeClass('open');
        setTimeout(function(){
          dropdownModal.hide();
        },delay);
      },
      options
    )
    dropdownModal.show();
  });

  $('#pdp-fixed-bar').css('top', $('#header').outerHeight()+'px');

  var fixedBar = $('#pdp-fixed-bar');
  var fixedBarSelects = fixedBar.find('select');
  $(window).scroll($.throttle(15, function() {
    var offset = productInfo.offset().top + productInfo.outerHeight() - $('#header').outerHeight();
    if ($(window).scrollTop()>offset) {
      fixedBar.addClass('open');
    } else {
      fixedBar.removeClass('open');
      fixedBarSelects.selectmenu('close');
    }
  }));

  fixedBarSelects.each(function(ix, select) {
    var options = {
      position: { my : "center top-15", at: "center center" },
      className: 'fixed-bar-ddl'
    };
    if (select.id == "fxb-option-color")
      options.width = 200;
    Simplistic.customDropdown(select, options);

  });
  fixedBarSelects.change(function(event) {
    var $select = $(this);
    productWrap.find('[data-option-index="'+($select.data('option')-1)+'"] :radio[value="'+this.value+'"]').click();
  });

  fixedBar.find('.content-available .btn').click(function(event) {
    productItem.find('[name="add"]').click();
  });

  var checkHeight = function(){
    var mainImageHeight = ($(window).width() / 2) / $('.main-single-image').data('aspect');
    var pageContentHeight = $(window).height() - $('header').height();
    var infoContentHeight = $('.product-info .nav-and-main').outerHeight() + $('.product-info .product-info-footer').outerHeight();
    if(window.innerWidth > 900 && mainImageHeight > pageContentHeight){
      if(infoContentHeight > pageContentHeight){
        $('.product-info-height').css({'height': 'auto', 'min-height': '0'});
      }else{
        $('.product-info-height').css({'height': pageContentHeight, 'min-height': infoContentHeight});
      }
      $('.main-single-image.bottom-align-image').css({'margin-top': 0 - (mainImageHeight - pageContentHeight)});

    }else{
      $('.product-info-height').css({'height': 'auto', 'min-height': '0'});
      $('.main-single-image').css('margin-top', '0');
    }
    $('.product-info-footer').css('visibility', 'visible');
  }
  $(window).resize($.throttle(15, function(){
    checkHeight();
  }));
  setTimeout(function(){
    checkHeight();
  },800);

  //reveal pdp
  if (window.innerWidth>900) {
  }
}

function article_scripts(articleData) {
  var $link = $('.link-back-to-blog');
  if ($link.length>0) {
    var html = $link.attr('href', articleData.blog.url).html();
    $link.html(html.replace('${blog.title}', articleData.blog.title));
  }

  function setFullHeight() {
    var hasUtilityBar = $('#header .utility-bar').length>0;
    var height = 'calc(var(--vh, 1vh) * 100 - '+( ( $('#header .main-content').outerHeight()/1) + $('.utility-bar').outerHeight()/1 ) +'px)';
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh+'px');
    $('.blog-content .min-height-full-top').css('min-height', height);
  }
  $(window).on('orientationchange', setFullHeight);
  setFullHeight();

  var matched = false;
  function matchHeightMobile($elements) {
    var maxHeight = 0;
    if (matched || window.innerWidth < 768) {
      $elements.css('min-height', '');
      $elements.each(function(ix, element) {
        var $element = $(element);
        maxHeight = Math.max(maxHeight, $element.height());
      });
      matched = false;
    }
    if (window.innerWidth < 768) {
      matched = true;
      $elements.each(function(ix, element) {
        $(element).css('min-height', maxHeight+'px');
      });
    }
  }

  var slicked = false;
  var mhbTid = 0;
  var layoutTid = 0;

  function slickImageColumns() {
    $('.blog-content .image-columns-right, .blog-content .image-columns-left').each(function(ix, container) {
      var $container = $(container);
      var title = $container.find('.title');
      var text = $container.find('.text');
      var imgText = $container.find('.image-text-wrapper');
      var allDynamicElements = $container.find('.dyn-layout');
      var slidesContainer = $('<div class="carousel-slider"></div>');
      var carouselLayout = $('<div class="carousel-layout"></div>');
      $container.addClass('carousel-on');

      allDynamicElements.each(function (eix, element) {
        element.placeHolder = $('<span></span>');
        element.placeHolder.insertBefore($(element));
      })
      $container.append(carouselLayout);
      carouselLayout.append(title);
      carouselLayout.append(slidesContainer);
      slidesContainer.append(imgText);
      carouselLayout.append(text);
      slidesContainer.slick({
        arrows: false,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20.48vw 0 0px'
      });

    });
  }

  function unslickImageColumns() {
    $('.blog-content .image-columns-right, .blog-content .image-columns-left').each(function(ix, container) {
      var $container = $(container);
      var title = $container.find('.title');
      var text = $container.find('.text');
      var imgText = $container.find('.image-text-wrapper');
      var allDynamicElements = $container.find('.dyn-layout').not('.slick-cloned');
      var slidesContainer = $container.find('.carousel-slider');
      var carouselLayout = $container.find('.carousel-layout');
      $container.removeClass('carousel-on');
      slidesContainer.slick('unslick');

      allDynamicElements.each(function (eix, element) {
        $(element).insertAfter(element.placeHolder);
        $(element.placeHolder).remove();
        delete element.placeHolder;
      });
      carouselLayout.remove();

    });

  }

  function layout() {
    clearTimeout(layoutTid);
    layoutTid = setTimeout(function() {
      if (!slicked && window.innerWidth < 768) {
        slickImageColumns();
        $('.image-text > .shg-box-content').slick({
          slidesToShow: 1,
          arrows: false,
          dots: false,
          centerMode: true,
          centerPadding: '25.13vw 0 0px',
          responsive: [
            {
              breakpoint: 600,
              settings: {
                centerPadding: '1.5rem 0 0px',
                arrows: true,
                prevArrow: '',
                nextArrow: '<button type="button" class="right-arrow "><svg aria-hidden="true" focusable="false" tabindex="-1" role="presentation" class=" icon icon-arrow-long-right-2" viewBox="0 0 32 32"><path d="M21.1,5l10.6,10.4c0.4,0.4,0.4,1,0,1.3L21.1,27c-0.4,0.4-1,0.4-1.3,0c-0.4-0.4-0.4-1,0-1.3l9-8.8H1 c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-0.9,1-0.9h27.8l-9-8.8c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.2,0.1-0.5,0.3-0.7C20.1,4.6,20.7,4.6,21.1,5"></path></svg></button>'
              }
            }
          ]
        });
        slicked = true;
      }

      if (slicked && window.innerWidth >= 768) {
        unslickImageColumns();
        $('.image-text .slick-slider').slick('unslick');
        slicked = false;
      }

      clearTimeout(mhbTid);
      mhbTid = setTimeout(function(){
        matchHeightMobile($('.image-text .wrap > .shg-box-content')); //include cloned slides
      }, 50);
    }, 50);

  }

  $(window).resize($.throttle(50, layout));
  layout();

  var carouselSettings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    prevArrow: '<svg aria-hidden="true" focusable="false" tabindex="-1" role="presentation" class=" left-arrow icon icon-arrow-long-left-2" viewBox="0 0 32 32" style="-webkit-transform: rotateZ(180deg) translateY(50%); transform: rotateZ(180deg) translateY(50%); "><path d="M21.1,5l10.6,10.4c0.4,0.4,0.4,1,0,1.3L21.1,27c-0.4,0.4-1,0.4-1.3,0c-0.4-0.4-0.4-1,0-1.3l9-8.8H1 c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-0.9,1-0.9h27.8l-9-8.8c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.2,0.1-0.5,0.3-0.7C20.1,4.6,20.7,4.6,21.1,5"></path></svg>',
    nextArrow: '<svg aria-hidden="true" focusable="false" tabindex="-1" role="presentation" class=" right-arrow icon icon-arrow-long-right-2" viewBox="0 0 32 32"><path d="M21.1,5l10.6,10.4c0.4,0.4,0.4,1,0,1.3L21.1,27c-0.4,0.4-1,0.4-1.3,0c-0.4-0.4-0.4-1,0-1.3l9-8.8H1 c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-0.9,1-0.9h27.8l-9-8.8c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.2,0.1-0.5,0.3-0.7C20.1,4.6,20.7,4.6,21.1,5"></path></svg>',
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  $('.blog-content .quick-tips').each(function(ix, item) {
    var options = $.extend({},carouselSettings);
    var divSlider = $(item).find('.quick-tips-items > div.shg-box-content');
    if (divSlider.children().length > 0)
      options.slidesToShow = Math.min(options.slidesToShow, divSlider.children().length);
    divSlider.slick(options);
  })

  var productCarouselSettings = $.extend({}, carouselSettings, {
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '20.48vw 0 0px'
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '20.48vw 0 0px'
        }
      }
    ]
  });

  $('.blog-content .story-products').each(function(ix, item) {
    var $item = $(item);
    $item.addClass('pending');
    var options = $.extend({},productCarouselSettings);
    var productsImgs = $('.blog-content .story-products:eq('+ix+') .story-product-items > div img')
    var loadimagesIid = setInterval(function() {
      if (productsImgs.not('.shogun-lazyloaded').length == 0) {
        $item.removeClass('pending');
        clearInterval(loadimagesIid);
        /*
        options.responsive[0].settings.centerMode = false;
        delete options.responsive[0].settings.centerPadding;
        options.responsive[0].settings.slidesToShow=1;
        */
        $('.blog-content .story-products:eq('+ix+') .story-product-items > div.shg-box-content').slick(options);
      }
    }, 50);
  });

  $('.blog-content .quick-tips').each(function(ix, item) {
    $.fn.matchHeight('.blog-content .quick-tips:eq('+ix+') .slick-slide .title', 50); //include cloned slides
  });

  var navHoverConfig = {
    over: function () {
      var sm = $(this).find('.img-wrapper:first');
      sm.fadeIn();
    },
    timeout: 400,
    out: function () {
      var sm = $(this).find('.img-wrapper:first');
      sm.fadeOut();
    }
  };

  if (!isMobile.any) {
    $('.article-nav .item.has-image').hoverIntent(navHoverConfig);
  }
}


$(function() {$(document).on('click', '.simplistic-bis-trigger', function() {
    var customerEmail = $(this).data('email');
    var customModalText = $(this).data('modal-text')
    var variantId = $(this).closest('form').find('[name="id"]').val();
    var productId = $(this).closest('form').find('[name="product_id"]').val();
    Simplistic.bisModal({text: window.klaviyo_body_content, variant_id: variantId, product_id: productId, email: customerEmail, customModalText: customModalText});
  })
});

window.GORGIASCHAT_DISABLE_CONTRAST_COLOR = true

$(function() {
  var gorgiasChatInterval = window.setInterval(function () {
      if (window.GorgiasChat) {
        window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.
        
        if (GorgiasChat.isBusinessHours()) {
          $('.help-contact-item.chat, .help-contact-item.chat .online').show();
        }
      }
  }, 100);

});

function initGiftWrapping(id) {
  //basic polyfill using jquery;
  function fetch(url, params) {
    var result = $.ajax({
      type: params.method,
      url: url,
      data: JSON.parse(params.body),
      dataType: 'json'
    });

    result.error(function() {
      location.reload();
    })

    result.then = result.always;
    return result;
  }

  Shopify.Cart = Shopify.Cart || {};

  Shopify.Cart.GiftWrap = {};
  Shopify.Cart.GiftWrap.variant_id = id;

  Shopify.Cart.GiftWrap.set = function() {
    $('#loading-overlay').show();
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var dataUpdates = {}
    dataUpdates[Shopify.Cart.GiftWrap.variant_id] = 1;

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: dataUpdates, attributes: { 'gift-wrapping': true, 'gift-wrapping-apply': 'yes' } })
    };
    updatingCartRequest = fetch('/cart/update.js', request)
    .then(function(response) {
      //location.href = '/cart';
      window.cartPageRefreshCart({});
    });
  }

  Shopify.Cart.GiftWrap.remove = function() {
    $('#loading-overlay').show();
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var dataUpdates = {}
    dataUpdates[Shopify.Cart.GiftWrap.variant_id] = 0;

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: dataUpdates, attributes: { 'gift-wrapping': '', 'gift-wrapping-apply': '', 'gift-to': '', 'gift-from': '', 'gift-message': '', 'gift-note': '', 'gift-wrapping-apply': '' } })
    };
    updatingCartRequest = fetch('/cart/update.js', request)
    .then(function(response) {
      //location.href = '/cart';
      window.cartPageRefreshCart({});
    });
  }

  window.cartPageRefreshCart = window.cartPageRefreshCart || function() {
    updateCartDesc({});
  }
  var updatingCartRequest = new Promise(function(res, rej) {res();});
  var giftWrappingCheckbox = document.querySelector('[name="attributes\[gift-wrapping\]"]');
  var giftWrappingApplyCheckbox = document.getElementById('gift-wrapping-apply');
  var giftWrappingDonotapplyCheckbox = document.getElementById('gift-wrapping-donotapply');
  giftWrappingCheckbox.addEventListener("change", function(event) {
    if (event.target.checked) {addOrRemoveGift(false);} else {
      Shopify.Cart.GiftWrap.remove();
    }
  });
  function getGiftNote() {
    const to = $('#gift-to').val().trim();
    const from = $('#gift-from').val().trim();
    const message = $('#gift-message').val().trim();

    if (!to && !from && !message) {
      return '';
    }

    return `To: ${to}\nFrom: ${from}\nNote: ${message}\n`;
  }

  function validateLength(msgContainer, elements, maxLength) {
    var ok = true;
    elements.each(function(ix, item) {
      if (item.value.length > maxLength) {
        var removeQty = item.value.length - maxLength;
        msgContainer.html('ERROR: '+maxLength+' character limit. Please remove '+ (removeQty==1 ? '1 character' : removeQty +' characters' ) +' to proceed.').show();
        ok = false;
        $(item).addClass('error');
        return false;
      }
    });

    return ok;
  }

  function validateCharacters(msgContainer, elements) {
    var ok = true;
    var allowedCharacters = /^[0-9a-zA-Z \.\r\n]+$/;
    elements.each(function(ix, item) {
      if (item.value && !item.value.match(allowedCharacters)) {
        ok = false;
        $(item).addClass('error');
      }
    });
    if (!ok) {
      msgContainer.html('ERROR: Special characters not valid. Please remove any non alphabetic or numeric characters.').show();
      return false;
    }

    return true;
  }

  function addOrRemoveGift(add) {
    $('#loading-overlay').show();
    var note = add ? 'yes' : '';
    document.getElementById('gift-wrapping-apply').value = note;
    var headers = new Headers({ 'Content-Type': 'application/json' });
    var qty = add ? 1 : 0;
    giftWrappingDonotapplyCheckbox.checked = !add;
    giftWrappingApplyCheckbox.checked = add;
    var dataUpdates = {}
    dataUpdates[Shopify.Cart.GiftWrap.variant_id] = qty;

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ updates: dataUpdates, attributes: { 'gift-wrapping': add, 'gift-wrapping-apply': note } })
    };

    updatingCartRequest = fetch('/cart/update.js', request)
    .then(function(response) {
      //location.href = '/cart';
      window.cartPageRefreshCart({});
    });

  }

  giftWrappingDonotapplyCheckbox.addEventListener("change", function(evt) {
    addOrRemoveGift(!evt.target.checked);
  });

  giftWrappingApplyCheckbox.addEventListener("change", function(evt) {
    addOrRemoveGift(evt.target.checked);
  });

  document.querySelector('#gift-to').addEventListener("change", function(evt) {
    var value = evt.target.value;
    var note = getGiftNote();
    var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ attributes: { 'gift-to': value, 'gift-note': note } })
    };

    updatingCartRequest = fetch('/cart/update.js', request);
  });

  document.querySelector('#gift-from').addEventListener("change", function(evt) {
    var value = evt.target.value;
    var note = getGiftNote();
    var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ attributes: { 'gift-from': value, 'gift-note': note } })
    };

    updatingCartRequest = fetch('/cart/update.js', request);
  });

  document.querySelector('#gift-message').addEventListener("change", function(evt) {
    var value = evt.target.value;
    var note = getGiftNote();
    var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ attributes: { 'gift-message': value, 'gift-note': note} })
    };

    updatingCartRequest = fetch('/cart/update.js', request);
    updateCharCount(this, document.getElementById('gift-message-charcount'));
  });
  document.querySelector('#gift-message').addEventListener("input", function(evt) {
    updateCharCount(this, document.getElementById('gift-message-charcount'));
  });
  function updateCharCount(srcElement, charcountElement) {
    charcountElement.innerHTML = srcElement.value.length + '/' + charcountElement.dataset.max;
  }

  updateCharCount(document.getElementById('gift-message'), document.getElementById('gift-message-charcount'));

  if (!Shopify.Cart.GiftWrap.delegateValidationsInitialized) {
    Shopify.Cart.GiftWrap.delegateValidationsInitialized = true;
    $('body').delegate('.btn-checkout', 'click', function(event){
      updatingCartRequest.then(function() {
        if (document.getElementById('gift-wrapping').checked) {
          $('#is-a-gift .error').removeClass('error');
          var msgDiv = $('#is-a-gift .error-msg');
          msgDiv.html('');
          if (!validateLength(msgDiv, $('#gift-to, #gift-from'), 50)) {
            return false;
          }
          if (!validateLength(msgDiv, $('#gift-message'), 150)) {
            return false;
          }if (document.getElementById('gift-wrapping-donotapply').checked) {
            if (!$('#gift-to').val() && !$('#gift-from').val() && !$('#gift-message').val()) {
              msgDiv.html('When sending just a note, please complete at least one of these fields.').show();
              $('#gift-to, #gift-from, #gift-message').addClass('error');
              if ($('#cart').length>0) {
                $.scrollTo(msgDiv, 500, {offset: -50 -$('#header').height()});
              }

              return false;
            }
          }
        }

        /* save fields one last time in case any previous update failed,
            this is a weird issue happening on IE11
          */
        var note = getGiftNote();

        var headers = new Headers({ 'Content-Type': 'application/json' });

        var attributes = {};
        var to = $('#gift-to').val();
        var from = $('#gift-from').val();
        var message = $('#gift-message').val();
        var note = getGiftNote();

        if (to) attributes['gift-to'] = to;
        if (from) attributes['gift-from'] = from;
        if (message) attributes['gift-message'] = message;
        if (note) attributes['gift-note'] = note;

        var data = JSON.stringify({ attributes: attributes });

        var request = {
          method: 'POST',
          headers: headers,
          body: data
        };
        updatingCartRequest = fetch('/cart/update.js', request)
        updatingCartRequest.then(function() {
          location = '/checkout';
        });

      })
      return false;
    });
  }

}



sJSq.forEach(function(f){f();});
sJS=function(f){f();}
